import React from 'react';

const path = '../oldPages/user-management/trusted-browsers/index.html';

function UserManagementTrustedBrowsers() {
  return <iframe title="user-management-trusted-browsers" src={path} width="100%" height="600px" />;
}

export default UserManagementTrustedBrowsers;
